/**
 * Global vuex actions.
 */
import { http } from '@/plugins/http'
import { loadToken } from '@/helpers/jwt/parser'
import { get, isEmpty } from 'lodash'
import settings from './resources/settings'
import tenants from './resources/tenants'
import patient from './resources/patient'
import professional from './resources/professional'
import { get as find, set, clear } from '@/helpers/storage'

const UpdateUserData = ({commit}, user) => {
  commit('setUserData', user)
  set('user', user)
  return user
}

export default {
  loadProfessional: ({ commit }) => {
    commit('setLoading', true)
    return professional.get()
      .then(({data}) => {
        commit('setProfessionalData', data)
        commit('setLoading', false)
      })
      .catch(() => {
        commit('setLoading', false)
      })
  },
  loadPatient: ({ commit }) => {
    commit('setLoading', true)
    return patient.get()
      .then(({data}) => {
        commit('setPatientData', data)
        commit('setLoading', false)
      })
      .catch(() => {
        commit('setLoading', false)
      })
  },
  setupJWT: ({ commit, getters, dispatch }, tokenString = null) => {
    // if no token was passed, get it from the store.
    const currentToken = tokenString || get(getters.jwt, 'token')
    return loadToken(currentToken) // load the token
      .then((token) => {
        commit('setJWT', token)
        return token
      })
  },

  updateUserData: UpdateUserData,

  logout: ({ commit }) => {
    async function logoutAndClear () {
      await commit('clearUserData')
      await clear()

      return true
    }

    return logoutAndClear()
  },

  setupUser: ({ getters, dispatch, commit }) => {
    return dispatch('setupJWT').then(() => {
      return find('user')
        .then(user => !isEmpty(user) ? user : http.get('/v1/auth/user').then(({data}) => data))
        .then(user => {
          commit('setUserData', user)
          set('user', user)
          if (user.is_employee) {
            commit('setTenants', [])
            tenants.get()
              .then(({data}) => {
                commit('setTenants', data)
              }).catch(() => {
                commit('setTenants', [])
              })
          }

          return user
        })
    })
  },

  updateSettings: ({ commit, getters }) => {
    settings.update('', getters.settings)
      .then(() => {
        UpdateUserData({commit}, getters.user)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js